module.exports = __webpack_public_path__ + "img/phone.04a03915.svg";